import { FormInput, FormSelect, TriStateSelectOptions, spreadAndtransformDefaultValues } from "@common/components/forms";
import { IAuthRoleModel } from "@common/models/Security";
import { IUserSearchAllFilter, UserSearchStore } from "@hospital/stores";
import { find, orderBy } from "lodash";
import { observer } from "mobx-react";
import React, { useCallback, useMemo } from "react";
import { Button, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';

export interface UsersFilterProps {
    store: UserSearchStore | null
    authRoles: IAuthRoleModel[];
}

export const UsersFilter = observer(({ store, authRoles }: UsersFilterProps) => {
    const { handleSubmit, reset, control } = useForm<IUserSearchAllFilter>({
        defaultValues: spreadAndtransformDefaultValues(store?.searchFilter)
    });

    const removeAllFilters = useCallback(() => {
        if (store) {
            store.resetSearchFilter();
            const freshDefaults = spreadAndtransformDefaultValues(store?.searchFilter);
			reset(freshDefaults); 
        }
    }, [store, reset]);

    const sortedAuthRoles = useMemo(() =>
        orderBy(authRoles, "description"), [authRoles])

    if (!store)
        return null; //return until store isn't undefined

    return (
        <Form onSubmit={handleSubmit(store.updateSearchFilter)}>
            <div className="mb-3">
                <FormInput label="First Name" fieldName="firstName" placeholder="First name" control={control} />
            </div>
            <div className="mb-3">
                <FormInput label="Last Name" fieldName="lastName" placeholder="Last name" control={control} />
            </div>
            <div className="mb-3">
                <FormInput label="Email" fieldName="emailAddress" placeholder="Email" control={control} />
            </div>
            <div className="mb-3">
                <FormSelect label="Role" control={control} fieldName="authRoleID"
                    isRequired={false}
                    options={sortedAuthRoles}
                    getOptionLabel={opt => opt.description}
                    getOptionValue={opt => opt.authRoleId.toString()}
                    mapValueToOption={authRoleId => find(authRoles, { authRoleId })}
                    mapOptionToValue={opt => opt?.authRoleId}
                />
            </div>
            <div className="mb-3">
                <FormSelect label="Active" fieldName="employmentstatusactive" control={control}
                    isRequired={false}
                    options={TriStateSelectOptions}
                    getOptionLabel={opt => opt.name}
                    getOptionValue={opt => opt.value === null ? '' : opt.value.toString()}
                    mapValueToOption={val => TriStateSelectOptions.filter(p => val === undefined ? p.value === null : p.value === val)[0]}
                    mapOptionToValue={opt => opt?.value === null ? undefined : opt?.value as boolean}
                />
            </div>
            <div className="mb-3">
                <FormInput label="Universal Provider Id" fieldName="universalProviderId" placeholder="Universal Provider Id" control={control} />
            </div>
            <Form.Group>
                <Button className="sideBarButton" variant="primary" type="submit">
                    Filter
                </Button>
                <Button className="sideBarButton" variant="outline-primary" onClick={removeAllFilters}>
                    Remove All Filters
                </Button>
            </Form.Group>
        </Form>
    )
});
